import axios from "axios";

export const addUser = (
  reqUser: string,
  email: string,
  givenName: string,
  familyName: string,
  phoneNumber: string,
  agency: string,
  jogId: string,
  roles: string[],
): any => {
  return axios.post("/user/v1", {
    reqUser,
    email: email.toLowerCase(),
    givenname: givenName,
    familyname: familyName,
    phonenumber: phoneNumber,
    agency: agency,
    jogId: jogId,
    enabled: "Y", // Defaulting to Y for enabled in cognito
    roles: roles,
  });
};

export const updateUser = (
  cognitoUsername: string,
  email: string,
  givenName: string,
  familyName: string,
  phoneNumber: string,
  agency: string,
  jogId: string,
  enabled: string,
  roles: string[],
  rolesToAdd: string[],
  rolesToRemove: string[],
  reqUser: string,
): any => {
  return axios.put("/user/v1", {
    reqUser,
    cognitoUsername: cognitoUsername,
    email: email.toLowerCase(),
    givenname: givenName,
    familyname: familyName,
    phonenumber: phoneNumber,
    agency: agency,
    jogId: jogId,
    enabled: enabled,
    roles: roles,
    rolesToAdd: rolesToAdd,
    rolesToRemove: rolesToRemove,
  });
};

export const reinviteUser = (email: string, reqUser: string): any => {
  return axios.put("/user/account/reinvite/", { email: email, reqUser });
};


// Review: Eventually depracate when updateUser handles this, have this data returned on GET user
export const getGroupsByUser = (email: string): any => {
  return axios.get("/user/v1/" + email + "/roles");
};

// Review: Eventually depracate when updateUser handles this
export const addUserToGroup = (cognitoUsername: string, group: string, reqUser: string): any => {
  return axios.post("/user/v1/cognitoUsername/" + cognitoUsername + "/groups/add", {
    cognitoUsername,
    groupname: group,
    reqUser,
  });
};

// Review: Eventually depracate when updateUser handles this
export const removeUserFromGroup = (cognitoUsername: string, group: string, reqUser: string): any => {
  return axios.put("/user/v1/cognitoUsername/" + cognitoUsername + "/groups/remove", {
    cognitoUsername,
    groupname: group,
    reqUser,
  });
};

export const getUsers = (email: string): any => {
  return axios.get("/user/email/" + email + "/all");
  //return axios.get("/user"); // todo: jcavner: We could go back to a path like this, and pass the requesting user as a query param.
};